import styled, { css } from "styled-components";

export const Text = styled.p`
  ${({ theme, size }) => css`
    margin: 0; //reset
    font-size: ${theme.font.size[size]};
  `}
`;
